module.exports = __webpack_public_path__ + "img/radio.6e1d56ee.png";